// DEV-4977/MC-13: read/create client for the versioned, effective-dated pricing-calendar config
// (PricingCalendarConfigController) — after-hours widen, weekend/holiday hold, SIFMA early-close cutoff,
// and the holiday list; company-wide only (no channel scope), reusing the guardrail governance claim
// group. Every call skips the global forbidden-reload: GETs degrade to the seed empty-state, and the
// create WRITE surfaces a 403 inline through the thunk mutation-error slice instead of triggering the
// page-reload interceptor.
import { SKIP_FORBIDDEN } from './httpConfig';

export class PricingCalendarApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCurrent() {
    return this.#http.get('/api/pricing-calendar-configs/current', SKIP_FORBIDDEN);
  }

  async getVersions() {
    return this.#http.get('/api/pricing-calendar-configs/versions', SKIP_FORBIDDEN);
  }

  async createVersion(body) {
    return this.#http.post('/api/pricing-calendar-configs', body, SKIP_FORBIDDEN);
  }
}
